import { faFloppyDisk, faPowerOff } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';


function Transactions({ children, controller }) {
    const { t } = useTranslation();

    useEffect(() => {

    }, [])

    return (
        <div className={`modal fade ${controller.modal?.mode}`} id="stockTxnModal" data-backdrop="static" data-keyboard="false" tabIndex={-1} role="dialog" aria-hidden="true">
            <div className={`modal-dialog ${controller.modal?.mode}`} role="document">
                <div className="modal-content">
                    <div className={`modal-header ${controller.modal?.bg}`}>
                        <h5 className="modal-title modal-add-title">{controller.modal?.title}</h5>
                        <button className="close" type="button" id={`close-addModalNew`} data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">×</span>
                        </button>
                    </div>
                    <div className="modal-body modalNew-add-detail">
                        {children}
                    </div>
                    <div className={`modal-footer ${controller.modal?.bg}`}>
                        <button className="btn btn-secondary btn-sm" type="button" id="close-modal-product" data-dismiss="modal" ><FontAwesomeIcon icon={faPowerOff} /> {t('close')}</button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Transactions;

